import ScrollToTop from "core/buttons/scroll-buttons/ScrollToTop";
import "./CorrespondenceTable.scss";
import { Table } from "core/table/Table";
import { FormattedMessage } from "react-intl";
import NoNesultIcon from "assets/icons/no-result.svg";
import { getFormattedDate } from "utils/functions";
import { getJobLabel, getStatusLabel } from "utils/workerHelper";
import React, { useContext } from "react";
import InfoContext from "pages/InfoContext";
import { QUERY_STATUS, SYMBOLS } from "constants/constants";
import { Link } from "react-router-dom";
import { renderIf } from "utils/helper";
import LoaderV2 from "core/loader/LoaderV2";
import InfiniteScroll from "react-infinite-scroller";
import Loader from "core/loader/Loader";
import { getMissionStatusLabel } from "utils/consultantHelper";
import { JOB_CATEGORY_LABEL } from "constants/forms";

const CorrespondenceByFilters = () => {
  const {
    lang,
    missionsList,
    loadTimelineCorrespondance,
    getMoreCorrespondanceTimelineMissions,
    personsList,
    userScope,
    jobList,
    jobCategoryList,
    clientsByIds,
    setIsLinkClick,
  } = useContext(InfoContext);

  const formatInfos = (val, infoType) => {
    switch (infoType) {
      case "person": {
        const personInfos = personsList?.find((person) => val === person.id);
        return `${personInfos?.first_name} ${personInfos?.last_name}`;
      }
      case "job": {
        const jobName = jobList?.find((job) => val === job.id);
        return lang === "fr" ? jobName?.fr : jobName?.en;
      }
      case "job_category":
        return jobCategoryList?.find((category) => category.id === val)
          ?.is_protected
          ? SYMBOLS.DASH
          : getJobLabel(jobCategoryList, val, lang);
      case "client": {
        const clientInfos = clientsByIds?.find((client) => val === client.id);
        return clientInfos?.name;
      }
      case "link":
        return (
          <Link
            to={`/${userScope}/missions/${val}`}
            onClick={() => setIsLinkClick(true)}
          >
            {" "}
            <FormattedMessage
              id="view_sheet"
              defaultMessage={"Voir la fiche"}
            />
          </Link>
        );
      case "computer":
        return (
          <FormattedMessage
            id={val ? "yes" : "no"}
            defaultMessage={val ? "Oui" : "Non"}
          />
        );

      default:
        break;
    }
  };

  const header = [
    {
      label: {
        key: "mission_title",
        value: <FormattedMessage id="title" defaultMessage={"Intitulé"} />,
      },
      icon: "missions",
      Width: "5%",
      id: "mission_title",
    },
    {
      label: {
        key: "client",
        value: <FormattedMessage id="client" defaultMessage={"Client"} />,
      },
      icon: "user",
      minWidth: "fit-content",
      id: "client",
    },
    {
      label: {
        key: "cslt_str",
        value: (
          <FormattedMessage id="worker_name" defaultMessage={"Cslt / Str"} />
        ),
      },
      icon: "user",
      minWidth: "fit-content",
      id: "cslt_str",
    },
    {
      label: {
        key: "manager",
        value: <FormattedMessage id="manager" defaultMessage={"Manager"} />,
      },
      icon: "user",
      minWidth: "fit-content",
      id: "manager",
    },
    {
      label: {
        key: "start_date",
        value: <FormattedMessage id="start" defaultMessage={"Début"} />,
      },
      icon: "calendar",
      minWidth: "fit-content",
      id: "start_date",
    },
    {
      label: {
        key: "end_date",
        value: <FormattedMessage id="end" defaultMessage={"Fin"} />,
      },
      icon: "calendar",
      minWidth: "fit-content",
      id: "end_date",
    },
    {
      label: {
        key: "status",
        value: <FormattedMessage id="status" defaultMessage={"Statut"} />,
      },
      icon: "loading",
      minWidth: "fit-content",
      id: "status",
    },
    {
      label: {
        key: "job_category",
        value: <FormattedMessage {...JOB_CATEGORY_LABEL} />,
      },
      icon: "project",
      minWidth: "fit-content",
      id: "job_category",
    },
    {
      label: {
        key: "job",
        value: (
          <FormattedMessage
            id="input_dav_function_label"
            defaultMessage={"Métier"}
          />
        ),
      },
      icon: "project",
      minWidth: "fit-content",
      id: "job",
    },
    {
      label: {
        key: "computer",
        value: <FormattedMessage id="computer" defaultMessage={"Ordinateur"} />,
      },
      icon: "computer",
      minWidth: "fit-content",
      id: "computer",
    },
    {},
  ];

  const contents = (missionsList) =>
    missionsList?.map((elem) => {
      const {
        mission_name,
        client_name,
        activity_start_date,
        activity_end_date,
        mission_status,
        mission_domain_category_id,
        mission_domain_id,
        mission_computer,
        mission_slug,
        worker_status,
        worker_first_name,
        worker_last_name,
        manager_name,
      } = elem;
      const worker_full_name = `${worker_first_name} ${worker_last_name}`;
      return {
        mission_title: renderIf(
          mission_name,
          mission_name,
          getMissionStatusLabel(worker_status)
        ),
        client: renderIf(client_name, client_name, SYMBOLS.DASH),
        cslt_str: renderIf(worker_full_name, worker_full_name, SYMBOLS.DASH),
        manager: renderIf(manager_name, manager_name, SYMBOLS.DASH),
        start_date: renderIf(
          activity_start_date,
          getFormattedDate(activity_start_date, lang),
          SYMBOLS.DASH
        ),
        end_date: renderIf(
          activity_end_date,
          getFormattedDate(activity_end_date, lang),
          SYMBOLS.DASH
        ),
        status: renderIf(
          mission_status,
          getStatusLabel(mission_status),
          getStatusLabel(getMissionStatusLabel(worker_status)) || SYMBOLS.DASH
        ),
        // Served by the back only once #12940 ships: a dash until then, since
        // the category of a mission cannot be deduced from its job — a job can
        // belong to several categories.
        job_category: renderIf(
          mission_domain_category_id,
          formatInfos(mission_domain_category_id, "job_category"),
          SYMBOLS.DASH
        ),
        job: renderIf(
          mission_domain_id,
          formatInfos(mission_domain_id, "job"),
          SYMBOLS.DASH
        ),
        computer: renderIf(
          mission_computer === null,
          SYMBOLS.DASH,
          formatInfos(mission_computer, "computer")
        ),
        mission_link: renderIf(
          mission_slug,
          formatInfos(mission_slug, "link"),
          SYMBOLS.DASH
        ),
      };
    });

  const loadMoreCorrespondanceTimelineMissions = () => {
    if (loadTimelineCorrespondance !== QUERY_STATUS.LOADING) {
      getMoreCorrespondanceTimelineMissions({
        page: missionsList.page + 1,
      });
    }
  };

  return (
    <div className="section">
      <ScrollToTop />

      <div>
        {loadTimelineCorrespondance === QUERY_STATUS.LOADING && <LoaderV2 />}

        {missionsList.content?.length === 0 &&
          loadTimelineCorrespondance === QUERY_STATUS.SUCCESS && (
            <div className="no-result-wrapper">
              <img
                src={NoNesultIcon}
                alt="no-result-icon"
                className="no-result-icon"
              />
              <p className="title-4 violet no-result-text">
                <FormattedMessage
                  id="no_results"
                  defaultMessage="Oops, aucun résultat pour cette recherche."
                />
              </p>
            </div>
          )}

        {missionsList.content?.length > 0 && (
          <InfiniteScroll
            pageStart={0}
            loadMore={loadMoreCorrespondanceTimelineMissions}
            hasMore={missionsList.content?.length < missionsList.total}
            loader={<Loader key={missionsList.page} id={missionsList.page} />}
          >
            <Table
              id={`missions-by-filters`}
              header={header}
              content={contents(missionsList.content) || []}
              tableWidth={"100%"}
              toolsManagerMission={false}
              userScope={userScope}
            />
          </InfiniteScroll>
        )}
      </div>
    </div>
  );
};

export default CorrespondenceByFilters;
